import { InputNumber, SelectPicker } from "rsuite";
import AppColorPicker from "../../../../../elements/AppColorPicker";
import { FormBuilder } from "../../../../../types/FormBuilderInterfaces";
import { ColorPickerWrapper } from "./GeneralStyles";

interface Props {
  form: FormBuilder;
  setForm: (value: any, key: string) => void;
}

const fieldsPerRow = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
];

const FieldStyles = ({ form, setForm }: Props) => {
  const handleSetForm = (value: any, key: string) => {
    setForm({ ...form.FieldStyles, [key]: value }, "FieldStyles");
  };

  return (
    <div className="d-flex flex-column" style={{ gap: "5px" }}>
      <ColorPickerWrapper title="Label Color">
        <AppColorPicker
          value={form.FieldStyles?.LabelsColor || "#ffffff"}
          onChange={(value) => handleSetForm(value, "LabelsColor")}
          onClear={() => handleSetForm("#000000", "LabelsColor")}
        />
      </ColorPickerWrapper>
      <ColorPickerWrapper title="Input Border Color">
        <AppColorPicker
          value={form.FieldStyles?.InputBorderColor || "#ffffff"}
          onChange={(value) => handleSetForm(value, "InputBorderColor")}
          onClear={() => handleSetForm("#BDC9C2", "InputBorderColor")}
        />
      </ColorPickerWrapper>
      <ColorPickerWrapper title="Focus Color">
        <AppColorPicker
          value={form.FieldStyles?.FocusColor || "#ffffff"}
          onChange={(value) => handleSetForm(value, "FocusColor")}
          onClear={() => handleSetForm("#26B058", "FocusColor")}
        />
      </ColorPickerWrapper>
      <div className="d-flex flex-column mb-3">
        <label className="text-sm font-weight-500 text-dark">
          Border Radius (px)
        </label>
        <InputNumber
          value={form.FieldStyles?.BorderRadius}
          onChange={(value) => handleSetForm(value, "BorderRadius")}
        />
      </div>
      <ColorPickerWrapper title="Text Color">
        <AppColorPicker
          value={form.FieldStyles?.TextColor || "#ffffff"}
          onChange={(value) => handleSetForm(value, "TextColor")}
          onClear={() => handleSetForm("#000000", "TextColor")}
        />
      </ColorPickerWrapper>
      <ColorPickerWrapper title="Background Color">
        <AppColorPicker
          value={form.FieldStyles?.BackgroundColor || "#ffffff"}
          onChange={(value) => handleSetForm(value, "BackgroundColor")}
          onClear={() => handleSetForm("#ffffff", "BackgroundColor")}
        />
      </ColorPickerWrapper>
      <div className="d-flex flex-column mb-3" style={{ gap: "5px" }}>
        <label className="text-sm text-dark font-weight-500">
          Fields Per Row
        </label>
        <SelectPicker
          searchable={false}
          data={fieldsPerRow}
          value={form.FieldStyles?.FieldsPerRow}
          onChange={(value) => handleSetForm(value, "FieldsPerRow")}
          placeholder="Fields per row"
        />
      </div>
    </div>
  );
};

export default FieldStyles;
